export const AppTextStyles = {
  // Display styles
  displayLarge: {
    fontSize: '3.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  displayMedium: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.3,
  },
  displaySmall: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.4,
  },
  
  // Headline styles
  headlineLarge: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  headlineMedium: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  headlineSmall: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  
  // Title styles
  titleLarge: {
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  titleMedium: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  titleSmall: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  
  // Body styles
  bodyLarge: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },
  bodyMedium: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },
  bodySmall: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },
  
  // Label styles
  labelLarge: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  labelMedium: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  labelSmall: {
    fontSize: '0.625rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  
  // Button styles
  buttonLarge: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  buttonMedium: {
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  buttonSmall: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
};